import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const BugReportForm = ({ onClose }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: '', note: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_TEST_API_BASE_URL}/mail/send-bug?name=${encodeURIComponent(formData.name)}&note=${encodeURIComponent(formData.note)}`, {
        method: 'POST',
      });
      const data = await response.json();
      if (data.code === 1000) {
        setSuccess(true);
      } else {
        setError(data.message || 'Gửi báo lỗi thất bại.');
      }
    } catch (err) {
      setError('Có lỗi xảy ra. Vui lòng thử lại sau.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-modal">
      <div className="login-modal-content">
        <div className="login-modal-header">
          <h2>{t('bug_report')}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, color: '#4CAF50' }}>✓</div>
            <h3>{t('thank_you_for_reporting')}</h3>
            <p>{t('we_have_received_your_report')}</p>
            <button className="login-button" onClick={onClose}>{t('close')}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="bug-name">{t('your_name_or_nickname')}</label>
              <input
                type="text"
                id="bug-name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder={t('your_name_or_nickname')}
                disabled={isLoading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="bug-note">{t('bug_description')}</label>
              <textarea
                id="bug-note"
                name="note"
                value={formData.note}
                onChange={handleChange}
                required
                placeholder={t('bug_description')}
                rows="4"
                disabled={isLoading}
                style={{ width: '100%', borderRadius: 6, border: '1px solid #ddd', padding: 12 }}
              />
            </div>
            {error && <div className="error-message" style={{ marginBottom: 10 }}>{error}</div>}
            <button className="login-button" type="submit" disabled={isLoading}>
              {isLoading ? t('sending') : t('send_bug_report')}
            </button>
            <button className="login-button" type="button" onClick={onClose} style={{ marginLeft: 8 }}>
              {t('close')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default BugReportForm; 
